/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Inspector_LabelInputs */

const en_home_bench_inspector_label = /** @type {(inputs: Home_Bench_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources and approval`)
};

const lv_home_bench_inspector_label = /** @type {(inputs: Home_Bench_Inspector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoti un apstiprinājums`)
};

/**
* | output |
* | --- |
* | "Sources and approval" |
*
* @param {Home_Bench_Inspector_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_inspector_label = /** @type {((inputs?: Home_Bench_Inspector_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Inspector_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_inspector_label(inputs)
	return en_home_bench_inspector_label(inputs)
});